import { Logger } from '../interface/Logger';

export class LoggerConsole implements Logger {
  constructor() {}
  error(ex: any): void {
    console.error(ex);
  }
  warn(ex: any): void {
    console.warn(ex);
  }
  debug(ex: any): void {
    console.debug(ex);
  }
  info(ex: any): void {
    console.info(ex);
  }
  critical(ex: any): void {
    console.error(ex);
  }
  trace(ex: any): void {
    console.log(ex);
  }
}
